// extracted by mini-css-extract-plugin
export default {"title":"i8ryWh"};